import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { axiosBeyonClient } from "utils/beyonAuth/beyonAxiosClient";

const zeusApi = "https://api.beca.digital/zeus/v1"

export function usePermission(permission: Permission, workspaceId: string) {

    const queryKey = ['permission'];
    const query = useQuery({
        queryKey,
        queryFn: async () => {
            const response = await axiosBeyonClient.get<PermissionTree>(`${zeusApi}/permission`);
            return response.data;
        },
        retryOnMount: false
    });

    return useMemo(() => {
        return verifyPermission(query.data, permission, workspaceId)
    }, [permission, workspaceId, query.data]);
}

export type PermissionTree = {
    global?: Permission[],
    solution?: Permission[],
    workspaces?: { [key: string]: Permission[] }
}


export function verifyPermission(permissionTree: PermissionTree, permission: Permission, workspaceId: string) {

    if (!permissionTree)
        return undefined;

    const hasGlobalPermission = permissionTree.global?.some(x => x === permission);
    if (hasGlobalPermission) return true;

    const hasWorkspaceSolution = permissionTree.solution?.some(x => x === permission);
    if (hasWorkspaceSolution) return true;

    if (!permissionTree.workspaces) return false;

    const workspacePermissions = permissionTree.workspaces?.[workspaceId];
    if (!workspacePermissions) return false;

    return workspacePermissions.some(x => x === permission);
}

export type Permission =
    "CreateSolution" |
    "CreateResourceWorkspace" |

    "ReadApplicationRole" |
    "EditApplicationRole" |

    "ReadResourceRole" |
    "EditResourceRole" |

    "CreateModuleStack" |
    "EditModuleStack" |

    "ReadNonProductionModuleStack" |

    "ReadResourceData" |
    "EditResourceData" |

    "ReadResourceConfiguration" |
    "EditResourceConfiguration"